import React, { useRef } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { Button, Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { uploadButton } from '../../lib/propTypes';
import { DEFAULT_BUTTON } from './constants';

import './style.scss';

const UploadButton = ({
    className,
    isDisabled = false,
    multiple = true,
    size = DEFAULT_BUTTON.size,
    color = DEFAULT_BUTTON.color,
    icon = DEFAULT_BUTTON.icon,
    title,
    showTitle = true,
    onUpload = noop,
    onClick = noop
}) => {
    const inputRef = useRef(null);

    const onChange = (event) => {
        onUpload(event);
        inputRef.current.value = '';
    };

    const onUploadClick = () => {
        inputRef.current.click();
        onClick();
    };

    const titleKey = multiple ? 'attach_files' : 'attach_file';

    const buttonClasses = classNames(
        'upload-button',
        className
    );

    const iconClasses = classNames(
        'upload-button-icon',
        { 'disabled': isDisabled }
    );

    return (
        <>
            <input type="file" hidden multiple={multiple}
                onChange={onChange} ref={inputRef}/>
            <Button className={buttonClasses} size={size} color={color}
                disabled={isDisabled} onClick={onUploadClick} type="button">
                {showTitle && (
                    <p className="upload-button-title">
                        {title || <I18n k={`file_uploader.upload_button.${titleKey}`}/>}
                    </p>
                )}
                <Icon size={14} disabled={isDisabled} className={iconClasses}>
                    {icon()}
                </Icon>
            </Button>
        </>
    );
};

UploadButton.propTypes = uploadButton;

export default UploadButton;
